/**
 * Helpdesk Kanban Configuration
 * 
 * Configuration for the Helpdesk kanban board using the global Kanban component.
 */

import { KanbanConfig } from '../types';
import { HelpdeskTicketInterface, TicketInternalStatus } from 'shared/types/helpdesk';
import { helpdeskPhaseColumns } from 'screens/helpdesk/helpdeskPhaseConfig';

/**
 * Helpdesk Kanban Configuration
 * 
 * This config defines how the Helpdesk kanban should look and behave:
 * - Uses phase columns from helpdeskPhaseConfig (single source of truth)
 * - Shows count per column
 * - Scrollable columns with max height
 * - Grid layout automatically adapts to number of columns (5 statuses)
 */
// @ts-ignore - Type constraint issue with optional id in HelpdeskTicketInterface type
export const helpdeskKanbanConfig: KanbanConfig<HelpdeskTicketInterface, TicketInternalStatus> = {
  // Column definitions from existing helpdeskPhaseConfig
  columns: helpdeskPhaseColumns,
  
  // Get the status for a ticket
  getItemStatus: (ticket: HelpdeskTicketInterface) => ticket.internalStatus,
  
  // Show count badge per column
  showCount: true,
  
  // No add button for helpdesk tickets (use separate quick add button)
  showAddButton: false,
  
  // Empty state configuration
  emptyState: {
    message: 'Geen tickets',
  },

  // Use page scroll instead of per-column scrollbars for better UX
  scrollableColumns: false,
};
